import { useTranslation } from "react-i18next";
import Modal, { SimpleModalControls } from "../../components/Modal"
import { Button, Divider, FormControl, FormLabel, IconButton, Input } from "@chakra-ui/react";
import { useState, useEffect, ChangeEvent } from "react";
import { getAxiosInstance } from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import { TbTrash } from "react-icons/tb";


type SellingHistoryPrice = {
    id: string,
    priceId: string,
    price: {
        id: string,
        name: string,
        value: number,
        sellingHistoryPrice: null,
        createdAt: string,
    },
    priceReference: PriceReference[],
    productId: string
}

type PriceReference = {
    id: string,
    sellingHistoryPriceId: string,
    sellingHistoryPrice: null,
    links: string
}

interface EditPriceHistoryModal extends SimpleModalControls {
    sellingHistoryPrice: SellingHistoryPrice | null
    productId: string | undefined
}

type Price = {
    name: string,
    value: number
};

const ProductSellingPriceModal = (props: EditPriceHistoryModal) => {
    const { t } = useTranslation("translations");
    const [priceReference, setPriceReference] = useState<PriceReference[]>([]);
    const [links, setUpLinks] = useState<string[]>([]);
    const [price, setUpPrice] = useState<Price | null>({ name: "-", value: 0 });


    const createNewSellingPrice = async () => {
        try {
            await getAxiosInstance().post(`/ProductPriceHistory`, {
                productId: props.productId,
                name: price?.name,
                value: price?.value,
                links: links
            });

            toast.success(t("UPDATED_NEW_SELLING_PRICE_SUCCESSFULLY"), { position: toast.POSITION.BOTTOM_RIGHT });
            props.onClose();
        } catch (error) {
            toast.error(t("SOMETHING_WENT_WRONG"), { position: toast.POSITION.BOTTOM_RIGHT });
        }
    }

    const addNewLink = () => {
        setUpLinks([...links, ""])
    }

    const settingUpLinksForArray = (priceReference: PriceReference[] | undefined) => {
        let l: string[] = [];
        if (priceReference) {
            for (let n of priceReference) {
                l.push(n.links);
            }
        }
        setUpLinks(l);
    }

    const removeLink = (index: number) => {
        let arr = [...links];
        arr.splice(index, 1);
        setUpLinks(arr);
    }

    const setLinksValue = (index: number, value: string) => {
        let arr = [...links];
        arr[index] = value;
        setUpLinks(arr);
    }

    const setUpValues = (e: ChangeEvent<HTMLInputElement>) => {
        setUpPrice({ name: "-", value: +e.target.value });
    }


    useEffect(() => {
        if (props.sellingHistoryPrice) setPriceReference(props.sellingHistoryPrice?.priceReference)

        settingUpLinksForArray(props.sellingHistoryPrice?.priceReference)

        if (props.sellingHistoryPrice) {
            setUpPrice({ name: props.sellingHistoryPrice?.price?.name, value: props.sellingHistoryPrice?.price?.value })
        }
    }, [props.sellingHistoryPrice?.priceReference]);

    return (
        <>
            <Modal
                header={t("Edit Price")}
                isOpen={props.isOpen}
                onClose={props.onClose}
                secondaryActionName={t("Save")}
                secondaryActionEnabled={true}
                secondaryAction={() => { createNewSellingPrice() }}
            >
                <>
                    <FormControl>
                        <FormLabel> {t("Value")} </FormLabel>
                        <Input
                            isRequired
                            name='value'
                            type="number"
                            inputMode="numeric"
                            value={price?.value}
                            onChange={(e) => { setUpValues(e) }}
                        />
                    </FormControl>
                    <FormLabel className="mt-4">{t("Link's")}</FormLabel>
                    <Divider color={"teal.200"} />
                    {
                        links.map((c: any, index: number) =>
                            <FormControl className={"block"} key={index}>
                                <div className="mt-3 flex items-between">
                                    <IconButton
                                        onClick={() => removeLink(index)}
                                        left={"max"}
                                        aria-label='Delete link'
                                        className="mr-2"
                                        colorScheme="red"
                                        icon={<TbTrash />}
                                    />
                                    <Input
                                        isRequired
                                        name='link'
                                        onChange={(e) => { setLinksValue(index, e.target.value) }}
                                        value={c}
                                        placeholder={t("Link")}
                                    />
                                </div>
                            </FormControl>
                        )
                    }
                    <Button className="mt-2" onClick={(e) => { addNewLink() }}> {t("Add another link")}</Button>
                </>
            </Modal>
        </>
    )
}

export default ProductSellingPriceModal;